import React, { useCallback, useMemo, useState } from 'react';

import { Box, FormHelperText } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { InputHelperText, useInput, Validator } from 'react-admin';

import SelectRule from './SelectRule';

const RuleSelector = ({
  source,
  label,
  field,
  helperText = '',
  validate,
} : {
  source: string;
  label: string;
  field: 'id' | 'originationChainId' | 'name';
  helperText?: string | false;
  validate?: Validator | Validator[];
}) => {
  const {
    field: { value },
    fieldState: { error },
  } = useInput({ source, validate });
  const currentValues = useMemo(() => (Array.isArray(value) ? value : []), [value]);
  const [selectedFields, setSelectedFields] = useState<Set<string>>(new Set(currentValues));
  const { setValue } = useFormContext();

  const onSubmit = useCallback(() => {
    setValue(source, Array.from(selectedFields), { shouldValidate: true });
  }, [setValue, source, selectedFields]);

  const onClose = useCallback(() => {
    setSelectedFields(new Set(currentValues));
  }, [setSelectedFields, currentValues]);

  return (
    <Box
      marginBottom={helperText === false ? 0 : 4}
      justifyContent="center"
      sx={{
        width: '100%',
      }}
    >
      <SelectRule
        onChange={setSelectedFields}
        onClose={onClose}
        onSubmit={onSubmit}
        values={selectedFields}
        label={`Select ${label}`}
        field={field}
      />
      {!!error && (
        <FormHelperText error>
          <InputHelperText error={error.message} helperText={helperText} />
        </FormHelperText>
      )}
    </Box>
  );
};

export default RuleSelector;
